import axios from 'axios'
import momentTz from 'moment-timezone'
import * as Sentry from '@sentry/browser'

import * as API from './_apiSettings'
import * as routes from './_routesSettings'
import { deleteAuthToken, getAuthToken } from 'utils/authHelper'
import { getUtmProperties } from './mixpanel'


const createAxiosInstance = (headers) => {
  const instance = axios.create({
    baseURL: API.mainUrl
  })

  instance.interceptors.request.use((requestConfig) => {
    const authToken = getAuthToken()
    const utmParams = getUtmProperties()

    if (utmParams.utm_source) {
      requestConfig.headers['X-UTM-Source'] = utmParams.utm_source
      requestConfig.headers['X-UTM-Medium'] = utmParams.utm_medium
      requestConfig.headers['X-UTM-Campaign'] = utmParams.utm_campaign
      requestConfig.headers['X-UTM-Term'] = utmParams.utm_term
      requestConfig.headers['X-UTM-Content'] = utmParams.utm_content
    }

    requestConfig.headers = {
      ...requestConfig.headers,
      ...instance.defaults.headers,
      ...authToken && {
        'Authorization': `Bearer ${authToken}`
      },
      'Accept-Language': API.languageCode(),
      'Time-Zone': momentTz.tz.guess(true),
      ...(headers && { ...headers })
    }

    return requestConfig
  }, err => {
    return Promise.reject(err)
  })

  instance.interceptors.response.use((response) => {
    const responseData = response.data
    return responseData
  }, err => {
    if (err.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (err.response.status === 401) {
        deleteAuthToken()
        window.location.href = `${routes.LOGIN}?sessionExpired`
      }
    } else if (err.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      Sentry.captureException(err.request.responseText)
    } else {
      // Something happened in setting up the request that triggered an Error
      Sentry.captureException(err)
    }

    return Promise.reject(err)
  })

  return instance
}

const defaultInstance = createAxiosInstance()

export { createAxiosInstance }
export default defaultInstance
